__turbopack_context__.v({
  "blue": "HowWeBuildProductCard-module-scss-module__FTUW5G__blue",
  "container": "HowWeBuildProductCard-module-scss-module__FTUW5G__container",
  "content": "HowWeBuildProductCard-module-scss-module__FTUW5G__content",
  "ellipse": "HowWeBuildProductCard-module-scss-module__FTUW5G__ellipse",
  "green": "HowWeBuildProductCard-module-scss-module__FTUW5G__green",
  "listWrapper": "HowWeBuildProductCard-module-scss-module__FTUW5G__listWrapper",
  "orange": "HowWeBuildProductCard-module-scss-module__FTUW5G__orange",
  "pink": "HowWeBuildProductCard-module-scss-module__FTUW5G__pink",
  "root": "HowWeBuildProductCard-module-scss-module__FTUW5G__root",
});
